export default __webpack_public_path__ + "static/RE4-Sale-Signs-e3697456f006a80f3991d4dcae602e26.webp";